// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";

// Images
import { useEffect, useState } from "react";
import { timeConverter } from "timeConverter/timeConverter";

export default function OffersTableData(onActionClick, searchText, pendingOffers, myStorage, token) {
  const [timeNow, setTimeNow] = useState(Math.floor(Date.now() / 1000))

  function getStatus(status, expiration_2){
    if(status === "SUCCESS" && timeNow - expiration_2 > 0){
      return 'EXPIRED'
    }
    if(status === "CLOSED_SUCCESS"){
      return 'SUCCESS'
    }
    if(status === "CLOSED_OPERATOR" || status === "CLOSED_USER"){
      return status.replace("_", " ")
    }
    if(status === "FAILED"){
      return "FAILED"
    }
    return "IN PENDING"
  }

  function getStatusColor(status, expiration_2){
    const computedStatus = getStatus(status, expiration_2)
    if(computedStatus === "IN PENDING"){
      return "a"
    }
    if(computedStatus === "SUCCESS"){
      return "success"
    }
    if(computedStatus === "CLOSED OPERATOR" || computedStatus === "CLOSED USER" || computedStatus === "EXPIRED" || computedStatus === "FAILED" ){
      return "error"
    }
  }

  function handleActionClick(offer){
    onActionClick(offer)
  }

  useEffect(() => {
    setInterval(() => {
      setTimeNow(Math.floor(Date.now() / 1000));
    }, 1000);
  });

  function getFromLocalStorage(imageId){
    if(localStorage.getItem(imageId)){
      return 'data:image/png;base64,' + localStorage.getItem(imageId);
    }
    if(myStorage && imageId in myStorage){
      let data =  myStorage[imageId];
      return 'data:image/png;base64,' + data;
    }
    return null
  }

  const User = ({ imageId, name, level }) => (
      
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={getFromLocalStorage(imageId)} size='lg'></MDAvatar>
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography variant="caption">{"Level " + level}</MDTypography>
        </MDBox>
      </MDBox>

  );

  const Product = ({ title, properties }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {title}
      </MDTypography>
      {Object.keys(properties).map((property_key) => (
        <MDBox lineHeight={1} key={property_key} >
          <MDTypography variant="caption">{property_key+": "+properties[property_key]}
          </MDTypography>
        </MDBox>
        ))}
    </MDBox>
  );

  function getRows(offers){
    if(offers === null){
      return []
    }
    offers = offers['data']
    if(!('offers' in offers)){
      return []
    }
    offers = offers['offers']
    const searchTextUpperCase = searchText.toUpperCase()
    const filteredOffer = offers.filter((offer) => {
      if(offer['offer']['barcode'].includes(searchTextUpperCase)){
        return true;
      }
      return false;

    })
    return filteredOffer.map((offer) => (
              {
                code: (
                  <MDTypography variant="caption" color="text" fontWeight="medium">
                    {offer['offer']['barcode']}
                  </MDTypography>
                ),
                user: <User imageId={offer['avatar']['photo_id']} name={offer['avatar']['nickname']} level={offer['avatar']['level']}/>,
                product: <Product title={offer['product']['product_name']} properties={offer['product']['product_properties']} />,
                date: (
                  <>
                    {getStatus(offer['offer']['status'], offer['offer']['expiration_2']) !== "FAILED" && 
                    <>
                      <MDTypography variant="caption" color="error" fontWeight="medium" mr={5}>
                        {timeConverter(offer['offer']['expiration_1'])}
                      </MDTypography>
                      <MDTypography variant="caption" color="warning" fontWeight="medium">
                        {timeConverter(offer['offer']['expiration_2'])}
                      </MDTypography>
                    </>
                    }
                  </>
                ),
                status: <MDBadge badgeContent={getStatus(offer['offer']['status'], offer['offer']['expiration_2'])} color={getStatusColor(offer['offer']['status'], offer['offer']['expiration_2'])} size="lg" />,
                action: (
                  <>
                  {getStatus(offer['offer']['status'], offer['offer']['expiration_2']) !== "FAILED" && 
                  <MDButton onClick={() => handleActionClick(offer)}>
                    <MDBadge badgeContent={"View deal"} color="dark" variant="gradient" size="lg" />
                  </MDButton>
                  }   
                  </>
                )
              }
    ))

  }

  return {
    columns: [
      { Header: "offer barcode", accessor: "code", width: "10%", align: "left" },
      { Header: "", accessor: "user", width: "20%", align: "left" },
      { Header: "", accessor: "product", width: "20%", align: "left" },
      { Header: "expiration dates", accessor: "date", width: "30%", align: "center" },
      { Header: "status", accessor: "status",  width: "10%", align: "center" },
      { Header: "", accessor: "action", width: "10%", align: "center" },
    ],

    rows: getRows(pendingOffers),
  }
}
